import { Link, useLocation } from 'react-router-dom';
import { HiDeviceMobile, HiArrowLeft } from 'react-icons/hi';
import { useLanguage } from '@/contexts/LanguageContext';
import './MobileOnly.css';

interface MobileOnlyProps {
  title?: string;
  description?: string;
}

export default function MobileOnly({ 
  title,
  description
}: MobileOnlyProps) {
  const { t } = useLanguage();
  const location = useLocation();
  
  // Определяем заголовок и описание на основе пути
  const getTitle = () => {
    if (title) return title;
    if (location.pathname.includes('/playgrounds/')) return t('mobileOnly.playgroundCard.title');
    if (location.pathname === '/playgrounds') return t('mobileOnly.playgrounds.title');
    if (location.pathname.includes('/meetings/')) return t('mobileOnly.meetingCard.title');
    if (location.pathname === '/meetings') return t('mobileOnly.meetings.title');
    if (location.pathname === '/create-meeting') return t('mobileOnly.createMeeting.title');
    if (location.pathname === '/profile') return t('mobileOnly.profile.title');
    if (location.pathname === '/login') return t('mobileOnly.login.title');
    if (location.pathname === '/registration') return t('mobileOnly.registration.title');
    return t('mobileOnly.default.title');
  };
  
  const getDescription = () => {
    if (description) return description;
    if (location.pathname.includes('/playgrounds/')) return t('mobileOnly.playgroundCard.description');
    if (location.pathname === '/playgrounds') return t('mobileOnly.playgrounds.description');
    if (location.pathname.includes('/meetings/')) return t('mobileOnly.meetingCard.description');
    if (location.pathname === '/meetings') return t('mobileOnly.meetings.description');
    if (location.pathname === '/create-meeting') return t('mobileOnly.createMeeting.description');
    if (location.pathname === '/profile') return t('mobileOnly.profile.description');
    if (location.pathname === '/login') return t('mobileOnly.login.description');
    if (location.pathname === '/registration') return t('mobileOnly.registration.description');
    return t('mobileOnly.default.description');
  };
  return (
    <div className="mobile-only-container">
      <div className="mobile-only-content">
        <div className="mobile-only-icon">
          <HiDeviceMobile />
        </div>
        
        <h1 className="mobile-only-title">{getTitle()}</h1>
        <p className="mobile-only-description">{getDescription()}</p>
        
        <div className="mobile-only-buttons">
          <a 
            href="https://apps.apple.com/tr/app/playbase/id6754344676" 
            target="_blank" 
            rel="noopener noreferrer"
            className="mobile-only-button mobile-only-button-apple"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
            </svg>
            <span>{t('common.appStore')}</span>
          </a>
          
          <a 
            href="https://play.google.com/store/apps/details?id=com.sportsground.playbase&pli=1" 
            target="_blank" 
            rel="noopener noreferrer"
            className="mobile-only-button mobile-only-button-google"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
            </svg>
            <span>{t('common.googlePlay')}</span>
          </a>
        </div>
        
        <div className="mobile-only-footer">
          <Link to="/" className="mobile-only-link">
            <HiArrowLeft />
            <span>{t('common.backToHome')}</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
